
import React, { createContext, useState, useContext } from 'react';

const EemDataContext = createContext();

export const useEemData = () => {
  const context = useContext(EemDataContext);
  if (!context) {
    throw new Error('useEemData must be used within EemDataProvider');
  }
  return context;
};

export const EemDataProvider = ({ children }) => {
  const [eemTasks, setEemTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  return (
    <EemDataContext.Provider value={{ eemTasks, setEemTasks, loading, setLoading }}>
      {children}
    </EemDataContext.Provider>
  );
};